module.exports = __webpack_public_path__ + "static/vp2-animation.52b66ec3.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/vp2-animation.gif
// module id = 1304
// module chunks = 35783957827783